.widthOneHundred {
	width: 100%;
}
